export const SHIPPING_MODES_RESET_STATE = 'SHIPPING_MODES_RESET_STATE';
export const SHIPPING_MODES_CURRENT_ITEM = 'SHIPPING_MODES_CURRENT_ITEM';

export const SHIPPING_MODES_REQUEST_LOADING = 'SHIPPING_MODES_REQUEST_LOADING';
export const SHIPPING_MODES_REQUEST_SUCCESS = 'SHIPPING_MODES_REQUEST_SUCCESS';
export const SHIPPING_MODES_REQUEST_FAILED = 'SHIPPING_MODES_REQUEST_FAILED';

export const SHIPPING_MODES_CURRENT_ACTION = 'SHIPPING_MODES_CURRENT_ACTION';
export const SHIPPING_MODES_RESET_ACTION = 'SHIPPING_MODES_RESET_ACTION';